const RedBoxs = () => {
    return (
      <div>
      
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="px-1 flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              RedBox
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              RedBox service is specifically designed to send parcels of 1, 2, 3, 5, 10, 15, 20 and 25 kilograms at 
              very special rates. You can send all non-perishable items including fragile, to all major, local and 
              selected international destinations through our RedBox service.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center">
            <img src="/DomesticScrollingBanner/scrolling-image5.jpg" alt="" className="rounded-md max-w-[100%] sm:mt-[0rem] mt-[1rem]"/>
          </div>
        </div>
     
       </div>

    </div>

    )
};
export default RedBoxs;